import useLocaleText from 'components/useLocaleText'
import { Subtask } from 'constants/interfaces'
import keys from 'constants/keys'

// New action literals: each type can be translated independently, even when English labels match.
export const missingSubtaskActionLiterals = {
  poll: { key: 'tasks_execution_poll_action', fallback: { en: 'Answer', he: 'מענה' } },
  quiz: { key: 'tasks_execution_quiz_action', fallback: { en: 'Answer', he: 'מענה' } },
  text: { key: 'tasks_execution_text_action', fallback: { en: 'Answer', he: 'מענה' } },
  number: { key: 'tasks_execution_number_action', fallback: { en: 'Enter', he: 'הזנה' } },
  link: { key: 'tasks_execution_link_action', fallback: { en: 'Open', he: 'פתיחה' } },
  file: { key: 'tasks_execution_file_action', fallback: { en: 'Attach', he: 'צירוף' } },
  aiPhoto: { key: 'tasks_execution_ai_photo_action', fallback: { en: 'Take photo', he: 'צילום תמונה' } },
} as const

export const subtaskActionLiterals = {
  open: { key: 'tasks_execution_open', fallback: { en: 'Open', he: 'פתיחה' } },
  photo: { key: 't_take_a_photo', fallback: { en: 'Take photo', he: 'צילום תמונה' } },
  video: { key: 't_record_a_video', fallback: { en: 'Record video', he: 'צילום וידאו' } },
  ...missingSubtaskActionLiterals,
} as const

export function useSubtaskActionText(subtask: Subtask, completed = false): string | undefined {
  const t = useLocaleText(subtaskActionLiterals)
  if (completed) return t.open
  switch (subtask.type) {
    case keys.SUBTASK_TYPES.IMAGE_SUBTASK:
      return subtask.is_ai_enhanced ? t.aiPhoto : t.photo
    case keys.SUBTASK_TYPES.VIDEO_SUBTASKS:
      return t.video
    case keys.SUBTASK_TYPES.POLL_SUBTASK:
      return t.poll
    case keys.SUBTASK_TYPES.PRIVATE_POLL:
      return t.quiz
    case keys.SUBTASK_TYPES.OPEN_QUESTION:
      return subtask.is_numeric ? t.number : t.text
    case keys.SUBTASK_TYPES.LINK_SUBTASK:
      return t.link
    case keys.SUBTASK_TYPES.UPLOAD_FILE_SUBTASK:
      return t.file
  }
}
